// store.js
import { combineReducers, configureStore } from "@reduxjs/toolkit";

import projectReducer from "./features/project/projectSlice";
import reportReducer from "./features/reports/reportSlice";
import userReducer from "./features/users/userSlice";
import controlReducer from "./features/controls/controlSlice";
import evidenceReducer from "./features/evidence/evidenceSlice";

const rootReducer = combineReducers({
    project: projectReducer,
    report: reportReducer,
    users: userReducer,
    controls: controlReducer,
    evidence: evidenceReducer,
});

const store = configureStore({
    reducer: {
        rootReducer,
    }
});

export default store;